import React, { Component } from "react";
import axios from "axios";
import cookie from "react-cookies";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import update from "immutability-helper";
import { validated } from "react-custom-validation";
import $ from "jquery";
import { GET_FORMPOST, GET_DETAILDATA } from "../../../actions";
import { apiUrl, clientheaderconfig } from "../../Helpers/Config";
import {
  showLoader,
  hideLoader,
  showAlert,
  CompanyID,
  isEmpty,
  isSingleSelect,
  uploadFile,
  removeFile,
} from "../../Helpers/SettingHelper";
import PageLoader from "../../Helpers/PageLoader";
import Header from "../Layout/Header";
import Topmenu from "../Layout/Topmenu";
import Footer from "../Layout/Footer";
import Editor from "../Layout/Editor";

var module = "promotion";
var moduleName = "Promotions";
var modulePath = "/clientpanel/promotions";
class Form extends Component {
  constructor(props) {
    super(props);
    var editID = "";
    if (this.props.match.path === "/clientpanel/promotions/edit/:EditID") {
      editID = this.props.match.params.EditID;
    }
    this.state = {
      editID: editID,
      pageloading: false,
      postdata: {
        promoCode: "",
        promoTitle: "",
        promoStartDate: "",
        promoEndDate: "",
        promoItemMinQty: "",
        promoItemMiAmount: "",
        promoUsageType: "",
        promoType: "",
        promoValue: "",
        promoMaximumAmount: "",
        promoUsageCount: "",
        promoUsageCountCustomer: "",
        promoAvailability: [],
        promoShowCustomer: false,
        promoFreeDelivery: false,
        promoShortDescription: "",
        promoLongDescription: "",
        promoApplicableCustomer: [],
        promoThumbnail: "",
        promoStatus: "",
        action: "add",
      },
      btndisabled: false,
      loading: true,
      formpost: [],
      companyDetail: [],
      availabiltyList: [],
      customerList: [],
    };
    this.handleChange = this.handleChange.bind(this);
  }
  componentDidMount() {
    this.loadAvailabilty();
    this.loadCustomer();
    if (this.state.editID !== "") {
      var params = {
        params: "",
        url: `${apiUrl}${module}/detail/${this.state.editID}`,
        type: "client",
      };
      this.setState({ pageloading: true });
      this.props.getDetailData(params);
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.state.formpost !== nextProps.formpost &&
      this.props.formpost != nextProps.formpost
    ) {
      if (nextProps.formpost.length > 0) {
        hideLoader("submit_frm", "class");
        var errMsg = nextProps.formpost[0].message;
        if (nextProps.formpost[0].status === "ok") {
          showAlert("Success", errMsg, "success", "No");
          this.props.history.push(modulePath);
        } else {
          showAlert("Error", errMsg, "error", "No");
        }
      }
    }
    if (
      this.state.companyDetail !== nextProps.detaildata &&
      this.state.editID !== ""
    ) {
      this.setState({ companyDetail: nextProps.detaildata }, function () {
        if (nextProps.detaildata[0].status === "ok") {
          var result = nextProps.detaildata[0].result;

          var promoStatus = result.promoStatus == "A" ? "Active" : "In Active";
          var status =
            result.promoStatus !== "" && result.promoStatus !== null
              ? {
                  label: promoStatus,
                  value: result.promoStatus,
                }
              : "";

          var promotionCouponType = "";
          if (result.promoUsageType === "1") {
            promotionCouponType = "Multiple Use";
          } else if (result.promoUsageType === "2") {
            promotionCouponType = "One Time Use";
          }
          var promoUsageType = "";
          if (promotionCouponType !== "") {
            promoUsageType = {
              label: promotionCouponType,
              value: result.promoUsageType,
            };
          }
          var clientupdatedata = {
            promoCode: result.promoCode,
            promoTitle: result.promoTitle,
            promoStartDate:
              result.promoStartDate !== "" && result.promoStartDate !== null
                ? new Date(result.promoStartDate)
                : "",
            promoEndDate:
              result.promoEndDate !== "" && result.promoEndDate !== null
                ? new Date(result.promoEndDate)
                : "",
            promoItemMinQty: result.promoItemMinQty,
            promoItemMiAmount: result.promoItemMiAmount,

            promoUsageType: promoUsageType,
            promoType:
              result.promoType !== "" && result.promoType !== null
                ? {
                    label: result.promoType,
                    value: result.promoType.toLowerCase(),
                  }
                : "",
            promoValue: result.promoValue,
            promoMaximumAmount: result.promoMaximumAmount,
            promoUsageCount: result.promoUsageCount,
            promoUsageCountCustomer: result.promoUsageCountCustomer,
            promoAvailability:
              result.promoAvailability.length > 0
                ? result.promoAvailability
                : [],
            promoShowCustomer: result.promoShowCustomer,
            promoFreeDelivery: result?.promoFreeDelivery ?? false,
            promoShortDescription: result.promoShortDescription,
            promoLongDescription: result.promoLongDescription,
            promoApplicableCustomer:
              result.promoApplicableCustomer.length > 0
                ? result.promoApplicableCustomer
                : [],
            promoThumbnail:
              result.promoThumbnail !== "" && result.promoThumbnail !== null
                ? result.promoThumbnail
                : "",
            promoStatus: status,
            action: "edit",
          };
          this.setState({ postdata: clientupdatedata, pageloading: false });
        } else {
          this.setState({ pageloading: false });
          this.props.history.push(modulePath);
          showAlert("Error", "Invalid Company", "error");
        }
      });
    }
  }
  loadAvailabilty() {
    var urlShringTxt = apiUrl + "availability/companydropDownList";
    axios.get(urlShringTxt, clientheaderconfig).then((res) => {
      if (res.data.status === "ok") {
        this.setState({ availabiltyList: res.data.result });
      }
    }).catch((e) => {
      console.log(e)
    });
  }
  loadCustomer() {
    var urlShringTxt = apiUrl + "customer/dropDownList";
    axios.get(urlShringTxt, clientheaderconfig).then((res) => {
      if (res.data.status === "ok") {
        this.setState({ customerList: res.data.result });
      }
    }).catch((e) => {
      console.log(e)
    });
  }
  sateValChange = (field, value) => {
    this.setState({ btndisabled: value });
  };

  handleChange(checked, name) {
    this.setState({ checked });
  }

  /* signin - start*/
  fieldChange = (field, value) => {
    this.setState(
      update(this.state, { postdata: { [field]: { $set: value } } })
    );
  };

  handleSubmit = () => {
    showLoader("submit_frm", "class");
    var postData = this.state.postdata;

    let promoAvailability =
      postData.promoAvailability.length > 0
        ? postData.promoAvailability.map((item) => item.value)
        : [];
    let promoApplicableCustomer =
      postData.promoApplicableCustomer.length > 0
        ? postData.promoApplicableCustomer.map((item) => item.value)
        : [];

    var postObject = {
      promoCode: postData.promoCode,
      promoTitle: postData.promoTitle,
      promoStartDate: postData.promoStartDate,
      promoEndDate: postData.promoEndDate,
      promoItemMinQty: postData.promoItemMinQty,
      promoItemMiAmount: postData.promoItemMiAmount,
      promoUsageType: postData.promoUsageType?.value ?? "",
      promoType: postData.promoType?.value ?? "",
      promoValue: postData.promoValue,
      promoMaximumAmount: postData.promoMaximumAmount,
      promoUsageCount: postData.promoUsageCount,
      promoUsageCountCustomer: postData.promoUsageCountCustomer,
      promoAvailability:
        promoAvailability.length > 0 ? promoAvailability.join(",") : "",
      promoApplicableCustomer:
        promoApplicableCustomer.length > 0
          ? promoApplicableCustomer.join(",")
          : "",
      promoShowCustomer: postData.promoShowCustomer,
      promoFreeDelivery: postData.promoFreeDelivery,
      promoShortDescription: postData.promoShortDescription,
      promoLongDescription: postData.promoLongDescription,
      promoThumbnail: postData.promoThumbnail,
      promoStatus: postData.promoStatus?.value ?? "A",
    };

    var post_url = module;
    let method = "post";
    if (this.state.editID !== "") {
      post_url = `${module}/${this.state.editID}`;
      method = "update";
    }
    this.props.getFormPost(postObject, post_url, "client", method);
  };

  render() {
    return (
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header {...this.props} currentPage={"promotions"} />
          <div className="layout-page">
            <Topmenu />
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row mb-3">
                  <div className="col-lg-10 col-md-6">
                    <h4 className="fw-bold">
                      {this.state.editID !== "" ? "Update" : "Add New"}{" "}
                      {moduleName}
                    </h4>
                  </div>
                  <div className="col-lg-2 col-md-6 text-end">
                    <Link to={modulePath}>
                      <button
                        type="button"
                        className="btn btn-outline-primary waves-effect"
                      >
                        Back
                      </button>
                    </Link>
                  </div>
                </div>

                <PostForm
                  {...this.props}
                  fields={this.state.postdata}
                  btndisabled={this.state.btndisabled}
                  onChange={this.fieldChange}
                  onValid={this.handleSubmit}
                  sateValChange={this.sateValChange}
                  availabiltyList={this.state.availabiltyList}
                  customerList={this.state.customerList}
                  error_msg={this.state.error_msg}
                  onInvalid={() => {
                    console.log("Form invalid!");
                    setTimeout(function () {
                      if ($("#modulefrm .is-invalid").length > 0) {
                        $("html, body").animate(
                          {
                            scrollTop:
                              $(document)
                                .find("#modulefrm .is-invalid:first")
                                .offset().top - 100,
                          },
                          500
                        );
                      }
                    }, 500);
                  }}
                />
              </div>

              <Footer />
            </div>
          </div>
        </div>

        <div className="layout-overlay layout-menu-toggle"></div>
        <div className="drag-target"></div>
        <PageLoader pageloading={this.state.pageloading} />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    formpost: state.formpost,
    detaildata: state.detaildata,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getFormPost: (formPayload, postUrl, authType, method) => {
      dispatch({ type: GET_FORMPOST, formPayload, postUrl, authType, method });
    },
    getDetailData: (datas) => {
      dispatch({ type: GET_DETAILDATA, datas });
    },
  };
};

export default connect(mapStateTopProps, mapDispatchToProps)(Form);

function validationConfig(props) {
  const { promoCode, promoStartDate, promoEndDate, promoStatus } = props.fields;

  return {
    fields: ["promoCode", "promoStartDate", "promoEndDate", "promoStatus"],

    validations: {
      promoCode: [[isEmpty, promoCode]],
      promoStartDate: [[isEmpty, promoStartDate]],
      promoEndDate: [[isEmpty, promoEndDate]],
      promoStatus: [[isSingleSelect, promoStatus]],
    },
  };
}

class PostForm extends Component {
  constructor(props) {
    super(props);
    this.setContent = this.setContent.bind(this);
    this.setLongContent = this.setLongContent.bind(this);
  }

  handleChange(name, value) {
    this.props.onChange(name, value);
  }
  handleSelectChange(name, value) {
    this.props.onChange(name, value);
  }
  handleChangeDate(name, value) {
    this.props.onChange(name, value);
  }
  setContent(value) {
    this.props.onChange("promoShortDescription", value);
  }
  setLongContent(value) {
    this.props.onChange("promoLongDescription", value);
  }

  handleChangeCheck(name, event) {
    var value = event.target.checked ;
    this.props.onChange(name, value);
  }
  async uplaodFiles(imageType) {
    var loadID = "";
    var loadCont = "";
    if (imageType === "promoThumbnail") {
      loadID = "ImageContainer";
      loadCont = "ImageDetails";
    }

    this.props.sateValChange("btndisabled", true);
    showLoader(loadCont);
    showLoader(loadID);
    var imagefile = document.querySelector("#" + imageType);
    const file = imagefile.files[0];
    var fileDetail = await uploadFile(file, "promotion", "client");
    if (fileDetail.status === "ok") {
      this.props.onChange(imageType, fileDetail.url);
    }
    hideLoader(loadID);
    hideLoader(loadCont);
    $("#" + imageType).val("");
    this.props.sateValChange("btndisabled", false);
  }
  async removeImage(fileNamme, imageType) {
    var loadCont = "";
    if (imageType === "promoThumbnail") {
      loadCont = "ImageDetails";
    }
    showLoader(loadCont);
    var fileDetail = await removeFile(fileNamme, "client");
    if (fileDetail.status === "ok") {
      hideLoader(loadCont);
      this.props.onChange(imageType, "");
    }
  }

  render() {
    const { fields, onChange, onValid, onInvalid, $field, $validation } =
      this.props;
    let errMsgPromoCode,
      errMsgStartDate,
      errMsgEndDate,
      errMsgStatus = "";
    if ($validation.promoCode.error.reason !== undefined) {
      errMsgPromoCode = $validation.promoCode.show && (
        <span className="error">{$validation.promoCode.error.reason}</span>
      );
    }
    if ($validation.promoStartDate.error.reason !== undefined) {
      errMsgStartDate = $validation.promoStartDate.show && (
        <span className="error">{$validation.promoStartDate.error.reason}</span>
      );
    }
    if ($validation.promoEndDate.error.reason !== undefined) {
      errMsgEndDate = $validation.promoEndDate.show && (
        <span className="error">{$validation.promoEndDate.error.reason}</span>
      );
    }
    if ($validation.promoStatus.error.reason !== undefined) {
      errMsgStatus = $validation.promoStatus.show && (
        <span className="error">{$validation.promoStatus.error.reason}</span>
      );
    }

    return (
      <form className="card fv-plugins-bootstrap5" id="modulefrm">
        <div className="card-body row g-3">
          <div className="col-md-6">
            <div className="form-floating form-floating-outline mb-4">
              <input
                type="text"
                className={
                  errMsgPromoCode !== "" &&
                  errMsgPromoCode !== false &&
                  errMsgPromoCode !== undefined
                    ? "form-control is-invalid"
                    : "form-control"
                }
                name="promoCode"
                value={fields.promoCode}
                {...$field("promoCode", (e) =>
                  onChange("promoCode", e.target.value)
                )}
              />
              <label htmlFor="promoCode">
                Promo Code <span className="error">*</span>
              </label>
              {errMsgPromoCode}
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-floating form-floating-outline mb-4">
              <input
                type="text"
                className="form-control"
                name="promoTitle"
                value={fields.promoTitle}
                {...$field("promoTitle", (e) =>
                  onChange("promoTitle", e.target.value)
                )}
              />
              <label htmlFor="promoTitle">Title</label>
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-floating form-floating-outline mb-4">
              <input
                type="text"
                className="form-control"
                name="promoItemMinQty"
                value={fields.promoItemMinQty}
                {...$field("promoItemMinQty", (e) =>
                  onChange("promoItemMinQty", e.target.value)
                )}
              />
              <label htmlFor="promoItemMinQty">Cart Minimum Qty</label>
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-floating form-floating-outline mb-4">
              <DatePicker
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                showTimeSelect
                dropdownMode="select"
                className="form-control"
                selected={fields.promoStartDate}
                minDate={new Date()}
                dateFormat="d-MM-yyyy h:mm aa"
                placeholderText="Start Date *"
                onChange={this.handleChangeDate.bind(this, "promoStartDate")}
              />
              {errMsgStartDate}
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-floating form-floating-outline mb-4">
              <DatePicker
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                showTimeSelect
                dropdownMode="select"
                className="form-control"
                selected={fields.promoEndDate}
                minDate={
                  fields.promoStartDate !== ""
                    ? fields.promoStartDate
                    : new Date()
                }
                dateFormat="d-MM-yyyy h:mm aa"
                placeholderText="End Date *"
                onChange={this.handleChangeDate.bind(this, "promoEndDate")}
              />
              {errMsgEndDate}
            </div>
          </div>

          <div className="col-md-6">
            <div className="form-floating form-floating-outline mb-4">
              <input
                type="text"
                className="form-control"
                name="promoItemMiAmount"
                value={fields.promoItemMiAmount}
                {...$field("promoItemMiAmount", (e) =>
                  onChange("promoItemMiAmount", e.target.value)
                )}
              />
              <label htmlFor="promoItemMiAmount">
                Cart Minimum Amount <span className="error">*</span>
              </label>
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-floating form-floating-outline custm-select-box mb-4">
              <Select
                value={fields.promoUsageType}
                onChange={this.handleSelectChange.bind(this, "promoUsageType")}
                placeholder="Select Coupon Type"
                options={[
                  { value: "1", label: "Multiple Use" },
                  { value: "2", label: "One Time Use" },
                ]}
                isClearable={true}
              />
              <label className="select-box-label">
                Coupon Type<span className="error">*</span>
              </label>
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-floating form-floating-outline custm-select-box">
              <Select
                value={fields.promoType}
                onChange={this.handleSelectChange.bind(this, "promoType")}
                placeholder="Select Promotion Type"
                options={[
                  { value: "percentage", label: "Percentage" },
                  { value: "fixed", label: "Fixed" },
                ]}
                isClearable={true}
              />
              <label className="select-box-label">
                Promotion Type<span className="error">*</span>
              </label>
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-floating form-floating-outline mb-4">
              <input
                type="text"
                className="form-control"
                name="promoValue"
                value={fields.promoValue}
                {...$field("promoValue", (e) =>
                  onChange("promoValue", e.target.value)
                )}
              />
              <label htmlFor="promoValue">Percentage</label>
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-floating form-floating-outline mb-4">
              <input
                type="text"
                className="form-control"
                name="promoMaximumAmount"
                value={fields.promoMaximumAmount}
                {...$field("promoMaximumAmount", (e) =>
                  onChange("promoMaximumAmount", e.target.value)
                )}
              />
              <label htmlFor="promoMaximumAmount">Maximum Amount Applied</label>
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-floating form-floating-outline mb-4">
              <input
                type="text"
                className="form-control"
                name="promoUsageCount"
                value={fields.promoUsageCount}
                {...$field("promoUsageCount", (e) =>
                  onChange("promoUsageCount", e.target.value)
                )}
              />
              <label htmlFor="promoUsageCount">No Of Use</label>
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-floating form-floating-outline mb-4">
              <input
                type="text"
                className="form-control"
                name="promoUsageCountCustomer"
                value={fields.promoUsageCountCustomer}
                {...$field("promoUsageCountCustomer", (e) =>
                  onChange("promoUsageCountCustomer", e.target.value)
                )}
              />
              <label htmlFor="promoUsageCountCustomer">
                No Of Use Per Customer
              </label>
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-floating form-floating-outline custm-select-box mb-4">
              <Select
                value={fields.promoAvailability}
                onChange={this.handleSelectChange.bind(
                  this,
                  "promoAvailability"
                )}
                isMulti
                placeholder="Select Availabilty"
                options={this.props.availabiltyList}
                isClearable={true}
              />
              <label className="select-box-label">Availabilty</label>
            </div>
          </div>
          <div className="col-md-6">
            <div class="form-check form-check-inline mt-3">
              <input
                class="form-check-input"
                type="checkbox"
                checked={fields?.promoShowCustomer ?? false}
                onChange={this.handleChangeCheck.bind(
                  this,
                  "promoShowCustomer"
                )}
              />
              <label class="form-check-label" for="inlineCheckbox1">
                Show As Customer View
              </label>
            </div>
            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                type="checkbox"
                checked={fields.promoFreeDelivery}
                onChange={this.handleChangeCheck.bind(
                  this,
                  "promoFreeDelivery"
                )}
              />
              <label class="form-check-label" for="inlineCheckbox2">
                Free Delivery Charge
              </label>
            </div>
          </div>
          <div className="col-md-12">
            <div className="form-floating form-floating-outline custm-select-box">
              <Select
                value={fields.promoApplicableCustomer}
                onChange={this.handleSelectChange.bind(
                  this,
                  "promoApplicableCustomer"
                )}
                isMulti
                placeholder="Select Customer"
                options={this.props.customerList}
                isClearable={true}
              />
              <label className="select-box-label">Customer</label>
            </div>
          </div>
          <div className="col-md-12">
            <label>Short Description</label>
            <Editor
              setContent={this.setContent}
              data={fields.promoShortDescription}
            />
          </div>
          <div className="col-md-12">
            <label>Long Description</label>
            <Editor
              setContent={this.setLongContent}
              data={fields.promoLongDescription}
            />
          </div>
          <div className="col-md-6">
            <div className="form-floating form-floating-outline mb-4">
              <div className="mb-3" id="ImageContainer">
                <label htmlFor="formFile" className="form-label">
                  Thumbnail
                </label>
                <input
                  className="form-control"
                  type="file"
                  id="promoThumbnail"
                  onChange={(event) => {
                    this.uplaodFiles("promoThumbnail", event);
                    return false;
                  }}
                />
              </div>
            </div>
            {fields.promoThumbnail !== "" && (
              <div className="dz-preview dz-processing dz-image-preview dz-success dz-complete">
                <div className="dz-details" id="ImageDetails">
                  <div className="dz-thumbnail">
                    <img alt="" src={fields.promoThumbnail} />
                  </div>
                </div>
                <a
                  className="dz-remove"
                  href={void 0}
                  onClick={this.removeImage.bind(
                    this,
                    fields.promoThumbnail,
                    "promoThumbnail"
                  )}
                >
                  Remove file
                </a>
              </div>
            )}
          </div>
          <div
            className={
              errMsgStatus !== "" &&
              errMsgStatus !== false &&
              errMsgStatus !== undefined
                ? "col-md-6 error-select error"
                : "col-md-6"
            }
          >
            <div className="form-floating form-floating-outline custm-select-box">
              <Select
                value={fields.promoStatus}
                onChange={this.handleSelectChange.bind(this, "promoStatus")}
                placeholder="Select Status"
                options={[
                  { value: "A", label: "Active" },
                  { value: "I", label: "In Active" },
                ]}
                isClearable={true}
              />
              <label className="select-box-label">
                Status<span className="error">*</span>
              </label>
              {errMsgStatus}
            </div>
          </div>

          <div className="pt-1 pb-4 pt-1 text-end">
            <button
              type="button"
              disabled={this.props.btndisabled}
              className="btn btn-primary me-sm-3 me-1 waves-effect waves-light submit_frm"
              onClick={(e) => {
                e.preventDefault();
                if (!this.props.btndisabled) {
                  this.props.$submit(onValid, onInvalid);
                }
              }}
            >
              Submit
            </button>
            <Link to={modulePath}>
              <button
                type="reset"
                className="btn btn-label-secondary waves-effect"
              >
                Cancel
              </button>
            </Link>
          </div>
        </div>
      </form>
    );
  }
}
PostForm = validated(validationConfig)(PostForm);
